import {BrowserRouter as Router, Routes, Route, Link} from "react-router-dom";

import Header from "./components/Header.js";
import Intro from "./components/Intro.js";
import ProjectsSection from "./components/ProjectsSection.js";
import ProjectPage from "./components/ProjectPage.js";
import {useEffect, useState} from "react";
import PageNotFound from "./components/PageNotFound.js";
import "./styles/utilities.css";
import './App.css';

async function fetchPath(path, setState) {
  var i = 3;
  var result = null;
  var fetchResult = null;
  while (i-- > 0 && result == null){
    fetchResult = await fetch(path);
    
    if (fetchResult.status == 404){
      console.log("Failed to fetch: " + path);
      setState(null, 404);
      return 404;  
    }

    result = await (fetchResult).json();
  }
  setState(result, fetchResult.status);
  return fetchResult.status;
}

function Home(projects) {

  return (
  <main>
    <Intro/>

    <ProjectsSection projects={projects}/>
  </main>);
}

function AboutMe() {
  return (
    <main>
      
    </main>
  )
}

function Project() {
  const path = window.location.href;
  const projectName = path.slice(path.lastIndexOf("/")+1, path.length);
  const url = "/api/projects/"+projectName.replaceAll(" ", "-");

  const [project, setProject] = useState([]);

  useEffect(() => {
    fetchPath(url, (value, status) => {
      setProject({project: value, status: status});
    });
  }, []);

  //const projectName = "Glider Flight Simulator Joystick";
  return (
    <ProjectPage projectState={project}/>
  );
}

function App() {
  return (
    <div className="App">
    <Router>
      <Header/>
    
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/projects/*" element={<Project/>}/>
        <Route path="/*" element={<PageNotFound/>}/>
      </Routes>
    </Router>
    </div>
  );//  <Route path="/about-me" element={<AboutMe/>}/>
}

export default App;
